import THEME from "../../../theme";
import { fs } from "../utils/styles";

const geld = (n) => `${n >= 0 ? "+" : ""}${n.toFixed(2)} €`;

function veraenderungProzent(aktuell, vorher) {
  if (!vorher) return null;
  return ((aktuell - vorher) / Math.abs(vorher)) * 100;
}

export default function KpiKarten({ aktuellePeriode, vormonat }) {
  const gewinnAktuell = aktuellePeriode.vorlaeufiges_betriebsergebnis;
  const gewinnVorher = vormonat.vorlaeufiges_betriebsergebnis;
  const veraenderungBetrag = gewinnAktuell - gewinnVorher;
  const veraenderungProzentWert = veraenderungProzent(gewinnAktuell, gewinnVorher);
  const besser = veraenderungBetrag >= 0;

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 16, marginBottom: 20 }}>
      <div style={{ ...fs.karte, marginBottom: 0 }}>
        <p style={{ color: THEME.colors.textMuted, fontSize: THEME.fontSize.sm, margin: "0 0 6px" }}>Einnahmen</p>
        <p style={{ color: THEME.colors.success, fontSize: THEME.fontSize.xxl, fontWeight: 700, margin: 0 }}>{geld(aktuellePeriode.einnahmen_betrieblich)}</p>
      </div>
      <div style={{ ...fs.karte, marginBottom: 0 }}>
        <p style={{ color: THEME.colors.textMuted, fontSize: THEME.fontSize.sm, margin: "0 0 6px" }}>Ausgaben</p>
        <p style={{ color: THEME.colors.danger, fontSize: THEME.fontSize.xxl, fontWeight: 700, margin: 0 }}>{geld(aktuellePeriode.ausgaben_betrieblich)}</p>
      </div>
      <div style={{ ...fs.karte, marginBottom: 0, border: `2px solid ${gewinnAktuell >= 0 ? THEME.colors.success : THEME.colors.danger}` }}>
        <p style={{ color: THEME.colors.textMuted, fontSize: THEME.fontSize.sm, margin: "0 0 6px" }}>Vorläufiger Gewinn / Verlust</p>
        <p style={{ color: gewinnAktuell >= 0 ? THEME.colors.success : THEME.colors.danger, fontSize: THEME.fontSize.display, fontWeight: 700, margin: 0 }}>{geld(gewinnAktuell)}</p>
      </div>
      <div style={{ ...fs.karte, marginBottom: 0 }}>
        <p style={{ color: THEME.colors.textMuted, fontSize: THEME.fontSize.sm, margin: "0 0 6px" }}>Veränderung zum Vormonat</p>
        <p style={{ color: besser ? THEME.colors.success : THEME.colors.danger, fontSize: THEME.fontSize.xxl, fontWeight: 700, margin: 0 }}>
          {besser ? "↑" : "↓"} {geld(veraenderungBetrag)}
          {veraenderungProzentWert !== null && <span style={{ fontSize: THEME.fontSize.base }}> ({veraenderungProzentWert >= 0 ? "+" : ""}{veraenderungProzentWert.toFixed(1)}%)</span>}
        </p>
      </div>
    </div>
  );
}
